import React from 'react';
import { FormattedMessage } from 'react-intl';

const ServerError = ({error}) => {
  return (
    <div style={{textAlign:'center', margin:'50px 0'}}>
      <h4>
        <FormattedMessage id="app.servererror.message" defaultMessage="500"/>
      </h4>
      {error && (<pre>
        {typeof error === 'string' || typeof error === 'number' ? error : JSON.stringify(error)}
      </pre>)}
      <a href={window.location.pathname + window.location.search}> <FormattedMessage id="app.servererror.link" defaultMessage="Back"/> </a>
    </div>
  );
};

export default ServerError;
